export default {
  mutations: {
    closeModals (state) {
      document.querySelector('body').classList.remove('overflow_hidden')
      Object.keys(state.modals).map(key => {
        state.modals[key] = false
      })
    },
    openModal (state, modal_name) {
      document.querySelector('body').classList.add('overflow_hidden')
      Object.keys(state.modals).map(key => {
        state.modals[key] = key === modal_name
      })
    },
    setModalData (state, modal_data) {
      state.modals.modal_data = modal_data
    }
  },
  state: {
    modals: {
      client_create: false,
      master_create: false,
      register_main: false,
      register_client: false,
      register_confirm: false,
      register_master: false,
      register_password: false,
      login: false,
      review: false,
      newPassword: false,
      restore: false,
      auth_to_message: false,
      auth_to_sign_up: false,
      recovery: false,
      recoveryVerify: false,
      recoveryPassword: false,
      modal_data: null,

      rent: false,
      rent_checkout: false,
      buyPackages: false,
      buyPackagesOffline: false,
      mobileFilters: false,

      cabinet_master_client_history: false,
      new_client_modal: false,
      master_cabinet_settings_edit_modal: false,

      master_cabinet_calendar_details_of_booking: false,
      master_cabinet_calendar_details_of_recording: false,
      master_cabinet_calendar_edit_record: false,
      master_cabinet_calendar_new_booking: false,
      master_cabinet_calendar_new_record: false,
    }
  },
  getters: {
    isModalActive(state) {
      let isActive = false
      Object.keys(state.modals).forEach(key => {
        if (state.modals[key] && key !== 'modal_data') {
          isActive = true
        }
      })
      return isActive
    },
    modal_data: state => state.modals.modal_data,
    loginModal: state => state.modals.login,
    reviewModal: state => state.modals.review,
    newPasswordModal: state => state.modals.newPassword,
    authToMessage: state => state.modals.auth_to_message,
    authToSignUp: state => state.modals.auth_to_sign_up,
    restoreModal: state => state.modals.restore,
    registerMainModal: state => state.modals.register_main,
    registerClientModal: state => state.modals.register_client,
    registerMasterModal: state => state.modals.register_master,
    registerConfirmModal: state => state.modals.register_confirm,
    registerPasswordModal: state => state.modals.register_password,
    recoveryModal: state => state.modals.recovery,
    recoveryVerifyModal: state => state.modals.recoveryVerify,
    recoveryPasswordModal: state => state.modals.recoveryPassword,
    clientCreateModal: state => state.modals.client_create,
    masterCreateModal: state => state.modals.master_create,
    rentModal: state => state.modals.rent,
    rentCheckoutModal: state => state.modals.rent_checkout,
    buyPackagesModal: state => state.modals.buyPackages,
    buyPackagesOfflineModal: state => state.modals.buyPackagesOffline,
    mobileFiltersModal: state => state.modals.mobileFilters,
    modalDataModal: state => state.modals.modal_data,
    cabinetMasterClientHistory: state => state.modals.cabinet_master_client_history,
    newClientModal: state => state.modals.new_client_modal,
    masterCabinetSettingsEditModal: state => state.modals.master_cabinet_settings_edit_modal,
    masterCabinetCalendarDetailsOfBooking: state => state.modals.master_cabinet_calendar_details_of_booking,
    masterCabinetCalendarDetailsOfRecording: state => state.modals.master_cabinet_calendar_details_of_recording,
    masterCabinetCalendarEditRecord: state => state.modals.master_cabinet_calendar_edit_record,
    masterCabinetCalendarNewBooking: state => state.modals.master_cabinet_calendar_new_booking,
    masterCabinetCalendarNewRecord: state => state.modals.master_cabinet_calendar_new_record,
  },
}
